import { useQuery } from '@tanstack/react-query';
import { configApi } from '../../configApi';

export interface IExemptions {
  id: string;
  registration_code: number;
  selective_process_id: string;
  selective_process_name: string;
  selective_process_created_at: string;
  status: string;
  detail: string;
  subtype?: string | { id: string; name: string };
  attachments: IAttachmentProps[];
  type: string;
  exemption_confirmation: string;
  created_at: string;
}

export interface IAttachmentProps {
  id: string;
  name: string;
  description?: string;
  file: string;
  type: string;
  status: string;
  sent_by_client: boolean;
  created_at: string;
}

type ExemptionsResponse = IExemptions[] | { results?: IExemptions[]; data?: IExemptions[] };

const RequestMyExemption = async (): Promise<IExemptions[]> => {
  const response = await configApi.get<ExemptionsResponse>('candidate-area/candidate-exemptions/');

  if (Array.isArray(response.data)) {
    return response.data;
  }

  return response.data.results ?? response.data.data ?? [];
};

export const useRequestMyExemption = () => {
  return useQuery({
    queryKey: ['RequestMyExemption'],
    queryFn: RequestMyExemption,
    refetchOnWindowFocus: false,
  });
};

export const getRegistrationExemptions = (
  exemptions: IExemptions[] | undefined,
  registrationCode: string | undefined,
  selectiveProcessId: string | undefined,
) =>
  exemptions?.filter(
    (exemption) =>
      String(exemption.registration_code).padStart(6, '0') === String(registrationCode).padStart(6, '0') &&
      exemption.selective_process_id === selectiveProcessId,
  ) ?? [];
